<template>
  <div class="content">
    <base-header :choose-index="-1" ref="header_content"></base-header>
    <div class="middle_content">
      <!-- <div class="middle_content-input">
        <div
          class="middle_content-input-icon1"
          v-bgImg="require('@@/assets/img/westa/home/搜索按钮黑色.png')"
        ></div>
        <input class="middle_content-input-item" placeholder="蒸烤箱" v-model="searchKey" />
        <div
          class="middle_content-input-icon2"
          v-bgImg="require('@@/assets/img/westa/join/前往.png')"
        ></div>
      </div>-->
      <div class="middle_content-input">
        <el-input
          prefix-icon="el-icon-search"
          suffix-icon="el-icon-arrow-right"
          placeholder="搜索"
          v-model="searchKey"
        ></el-input>
      </div>
      <div class="middle_content-tab">
        <div class="middle_content-tab-list">
          <div
            class="middle_content-tab-item"
            :class="{'middle_content-tab-item-active': chooseTab === '产品'}"
            @click="chooseTab = '产品'"
          >产品</div>
          <div
            class="middle_content-tab-item"
            :class="{'middle_content-tab-item-active': chooseTab === '菜谱'}"
            @click="chooseTab = '菜谱'"
          >菜谱</div>
          <div
            class="middle_content-tab-item"
            :class="{'middle_content-tab-item-active': chooseTab === '新闻'}"
            @click="chooseTab = '新闻'"
          >新闻</div>
        </div>
      </div>
      <div class="middle_content-text">搜索3结果</div>
      <!-- <div class="middle_content-list" v-show="chooseTab === '产品'">
        <div class="middle_content-list-item1">
          <div
            class="middle_content-list-item1-pic"
            v-bgImg="require('@@/assets/img/westa/home/正面-关灯.png')"
          ></div>
          <div class="middle_content-list-item1-right">
            <div class="middle_content-list-item1-right-title">ZTB32Q蒸烤箱</div>
            <div class="middle_content-list-item1-right-desc">4.0全能蒸烤箱</div>
            <div
              class="middle_content-list-item1-right-btn"
              v-bgImg="require('@@/assets/img/westa/join/形状7_60.png')"
            ></div>
          </div>
        </div>
        <div class="middle_content-list-item1">
          <div
            class="middle_content-list-item1-pic"
            v-bgImg="require('@@/assets/img/westa/home/正面-关灯.png')"
          ></div>
          <div class="middle_content-list-item1-right">
            <div class="middle_content-list-item1-right-title">ZTB32Q蒸烤箱</div>
            <div class="middle_content-list-item1-right-desc">4.0全能蒸烤箱</div>
            <div
              class="middle_content-list-item1-right-btn"
              v-bgImg="require('@@/assets/img/westa/join/形状7_60.png')"
            ></div>
          </div>
        </div>
      </div>
      <div class="middle_content-list" v-show="chooseTab === '菜谱'">
        <div class="middle_content-list-item1">
          <div
            class="middle_content-list-item1-pic"
            v-bgImg="require('@@/assets/img/westa/home/正面-关灯.png')"
          ></div>
          <div class="middle_content-list-item1-right">
            <div class="middle_content-list-item1-right-title">ZTB32Q蒸烤箱</div>
            <div class="middle_content-list-item1-right-desc">4.0全能蒸烤箱</div>
            <div
              class="middle_content-list-item1-right-btn"
              v-bgImg="require('@@/assets/img/westa/join/形状7_60.png')"
            ></div>
          </div>
        </div>
        <div class="middle_content-list-item1">
          <div
            class="middle_content-list-item1-pic"
            v-bgImg="require('@@/assets/img/westa/home/正面-关灯.png')"
          ></div>
          <div class="middle_content-list-item1-right">
            <div class="middle_content-list-item1-right-title">ZTB32Q蒸烤箱</div>
            <div class="middle_content-list-item1-right-desc">4.0全能蒸烤箱</div>
            <div
              class="middle_content-list-item1-right-btn"
              v-bgImg="require('@@/assets/img/westa/join/形状7_60.png')"
            ></div>
          </div>
        </div>
        <div class="middle_content-list-item1">
          <div
            class="middle_content-list-item1-pic"
            v-bgImg="require('@@/assets/img/westa/home/正面-关灯.png')"
          ></div>
          <div class="middle_content-list-item1-right">
            <div class="middle_content-list-item1-right-title">ZTB32Q蒸烤箱</div>
            <div class="middle_content-list-item1-right-desc">4.0全能蒸烤箱</div>
            <div
              class="middle_content-list-item1-right-btn"
              v-bgImg="require('@@/assets/img/westa/join/形状7_60.png')"
            ></div>
          </div>
        </div>
      </div>
      <div class="middle_content-list" v-show="chooseTab === '新闻'">
        <div class="middle_content-list-item1">
          <div
            class="middle_content-list-item1-pic2"
            v-bgImg="require('@@/assets/img/westa/home/正面-关灯.png')"
          ></div>
          <div class="middle_content-list-item1-right2">
            <div class="middle_content-list-item1-right-title">ZTB32Q蒸烤箱</div>
            <div class="middle_content-list-item1-right-desc">4.0全能蒸烤箱</div>
            <div
              class="middle_content-list-item1-right-btn"
              v-bgImg="require('@@/assets/img/westa/join/形状7_60.png')"
            ></div>
          </div>
        </div>
      </div>-->
    </div>
    <base-footer></base-footer>
  </div>
</template>

<script>
import BaseHeader from "@@/components/westa/base-header";
import BaseFooter from "@@/components/westa/base-footer";
export default {
  data() {
    return {
      searchKey: "",
      chooseTab: "产品"
    };
  },
  components: {
    BaseHeader,
    BaseFooter
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>


<style lang="less" scoped>
.middle_content {
  padding-top: 64px;
  background: #f9f9f9;
  min-width: 1200px;
  &-input1 {
    width: 790px;
    height: 60px;
    margin: 0 auto;
  }
  &-input {
    width: 790px;
    height: 60px;
    margin: 0 auto;
    padding-top: 120px;
    display: flex;
    align-items: center;
    &-item {
      border: 0;
      outline: none;
      background: transparent;
      font-size: 16px;
      // color: #999;
      width: 646px;
    }
    &-icon1 {
      width: 24px;
      height: 24px;
      margin: 0 24px;
    }
    &-icon2 {
      width: 24px;
      height: 24px;
      margin: 0 24px;
    }
  }
  &-tab {
    width: 100%;
    margin-top: 50px;
    padding-bottom: 10px;
    border-bottom: 1px solid #dbdbdb;
    margin-bottom: 36px;
    &-list {
      display: flex;
      align-items: center;
      width: 790px;
      margin: 0 auto;
      font-size: 20px;
      color: #666;
    }
    &-item {
      margin-right: 88px;
      &-active {
        color: #000;
      }
    }
  }
  &-text {
    width: 790px;
    margin: 0 auto;
    color: #666;
    margin-bottom: 16px;
  }
  &-list {
    width: 790px;
    margin: 0 auto;
    &-item1 {
      width: 650px;
      height: 180px;
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      &-pic {
        width: 180px;
        height: 180px;
      }
      &-right {
        width: 470px;
        height: 180px;
        padding: 28px 36px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        &-title {
          font-size: 20px;
        }
        &-desc {
          font-size: 16px;
          color: #666;
        }
        &-btn {
          width: 88px;
          height: 36px;
        }
      }
      &-pic2 {
        width: 260px;
        height: 180px;
      }
      &-right2 {
        width: 390px;
        height: 180px;
        padding: 28px 36px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
      }
    }
  }
}
</style>


